import { useCallback, useEffect, useMemo } from "react";

import useMediaQuery from "@mui/material/useMediaQuery";
import { Box, Stack, Typography, useTheme } from "@mui/material";

import Toast from "@covertree/utils/Toast";

import { useSearchLazyQuery } from "@covertree/agent-portal-graphql";

import { SearchBox } from "@covertree/ui";

import { SearchResult } from "./SearchResult/SearchResult";
import {
  filterPolicies,
  filterQuotes,
  filterRenewals,
  filterSequoiaQuotes,
} from "./utils";

export function Search() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [searchQuery, { data, loading, error }] = useSearchLazyQuery();

  const search = useCallback(
    (queryString: string) => {
      searchQuery({
        variables: {
          query: queryString,
        },
      });
    },
    [searchQuery]
  );

  useEffect(() => {
    if (error) {
      Toast.showError("Unable to search. Please try again or contact us.");
    }
  }, [error]);

  const renderResults = useMemo(() => {
    if (data && data.search.length === 0) {
      return (
        <Typography variant="h3" justifyContent="center">
          No results found
        </Typography>
      );
    }
    return (
      <Stack spacing={2}>
        <SearchResult
          header="Policies"
          result={data?.search?.filter(filterPolicies)}
        />
        <SearchResult
          header="Renewals"
          result={data?.search?.filter(filterRenewals)}
        />
        <SearchResult
          header="Quotes"
          result={data?.search?.filter(filterQuotes)}
        />
        <SearchResult
          header="Sequoia Quotes"
          result={data?.search?.filter(filterSequoiaQuotes)}
        />
      </Stack>
    );
  }, [data]);

  return (
    <>
      <Box
        sx={{
          ...(isMobile
            ? {
                position: "absolute",
                right: theme.spacing(2),
                top: theme.spacing(1.5),
              }
            : {}),
        }}>
        <SearchBox
          title="Search policies, quotes and renewals"
          placeholder="Search by policy id, renewal id, name, email, address or phone number"
          loading={loading}
          searchFn={search}
          type="CUSTOM_CONTENT"
          resultsContent={renderResults}
        />
      </Box>
    </>
  );
}
